import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import styles from './AppInfoItem.module.scss';
import withCloseOnOuterClick from '../../common/HOCs/withCloseOnOuterClick';

const AppInfoModal = withCloseOnOuterClick(({ Component, inputRef }) => (
    <div ref={ inputRef } className={ styles.modal }>
        <Component />
    </div>
));

AppInfoModal.propTypes = {
    Component: PropTypes.func.isRequired
};

const AppInfoItem = ({ title, icon, Component }) => {
    const [isOpen, setIsOpen] = useState(false);

    const closeControl = useCallback((e) => {
        if (!e.isContextButtonClick) {
            setIsOpen(false);
        }
    }, []);

    const openControl = useCallback(() => setIsOpen(true), []);

    return (
        // eslint-disable-next-line jsx-a11y/interactive-supports-focus
        <div role="button" className={ styles.appInfoItem } onClick={ openControl }>
            <img
                src={ icon }
                alt={ title }
                className={ styles.menuIcon }
            />
            { isOpen && <AppInfoModal Component={ Component } closeControl={ closeControl } /> }
        </div>
    );
};

AppInfoItem.propTypes = {
    Component: PropTypes.func.isRequired,
    title: PropTypes.string,
    icon: PropTypes.string
};

AppInfoItem.defaultProps = {
    title: '',
    icon: ''
};

export default AppInfoItem;
